export default "__VITE_ASSET__YN7pCglQ__"